define("ember-changeset-validations/validators/presence", ["exports", "ember-changeset-validations/utils/validation-errors", "ember-validators/presence", "@ember/object"], function (_exports, _validationErrors, _presence, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = validatePresence;
  0; //eaimeta@70e063a35619d71f0,"ember-changeset-validations/utils/validation-errors",0,"ember-validators/presence",0,"@ember/object"eaimeta@70e063a35619d71f
  function validatePresence(options) {
    let targets;
    if (typeof options === 'boolean') {
      options = {
        presence: options
      };
    } else if (options && options.on !== undefined) {
      if (typeof options.on === 'string') {
        targets = [options.on];
      } else if (Array.isArray(options.on)) {
        targets = options.on;
      }
      delete options.on;
    }
    return (key, value, _oldValue, changes, content) => {
      if (targets && !targets.some(target => {
        const change = (0, _object.get)(changes, target);
        return change || change === undefined && (0, _object.get)(content, target);
      })) {
        return true;
      }
      let result = (0, _presence.default)(value, options, null, key);
      if (typeof result === 'boolean' || typeof result === 'string') {
        return result;
      } else {
        // We flipped the meaning behind `present` and `blank` so switch the two
        if (result.type === 'present') {
          result.type = 'blank';
        } else if (result.type === 'blank') {
          result.type = 'present';
        }
        return (0, _validationErrors.default)(key, result);
      }
    };
  }
});